/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeys } from '../../models/api-keys';

export interface ApiKeysDelete$Params {
  id: number;
}

export function apiKeysDelete(http: HttpClient, rootUrl: string, params: ApiKeysDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeys>> {
  const rb = new RequestBuilder(rootUrl, apiKeysDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeys>;
    })
  );
}

apiKeysDelete.PATH = '/api/ApiKeys/{id}';
